// Historia próbek urządzenia z bramy (`GET /brama/urzadzenia/{sn}/probki?od&do`, S-7): kubełki dobiera serwer
// (najwyżej ~1500 punktów na zakres), przerwy w danych to brak kubełków. Wykres zamienia odpowiedź na kolumny
// uPlot i wstawia lukę tam, gdzie odstęp między punktami jest większy niż dwa kroki.
import { zapytanie } from "../api/zaplecze";
import type { SamplesReply } from "../gen/kontrakt";

export type Kolumny = [number[], ...(number | null)[][]];

export interface Historia {
  krok: number;
  kanaly: SamplesReply["kanaly"];
  dane: Kolumny;
  /** Plakietki wykresu z zakresu - zmiany fazy przebiegu (WS-16) */
  znaczniki: SamplesReply["znaczniki"];
}

export async function pobierzProbki(sn: string, od: number, doS: number): Promise<Historia> {
  const o = await zapytanie<SamplesReply>("GET",
    `/brama/urzadzenia/${encodeURIComponent(sn)}/probki?od=${Math.floor(od)}&do=${Math.ceil(doS)}`);
  return { krok: o.krok, kanaly: o.kanaly, dane: zLukami(o.t, o.v, o.krok), znaczniki: o.znaczniki };
}

/** Kolumny z pustym punktem w każdej przerwie dłuższej niż dwa kroki (uPlot przerywa wtedy linię). */
export function zLukami(t: number[], v: (number | null)[][], krok: number): Kolumny {
  const ts: number[] = [];
  const kol = v.map((): (number | null)[] => []);
  for (let i = 0; i < t.length; i++) {
    const ti = t[i] ?? 0;
    const poprz = t[i - 1];
    if (poprz !== undefined && ti - poprz > 2 * krok) {
      ts.push(poprz + krok);
      for (const k of kol) k.push(null);
    }
    ts.push(ti);
    v.forEach((kanal, j) => kol[j]?.push(kanal[i] ?? null));
  }
  return [ts, ...kol];
}
